import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    user: {},
    emofUserTokenSafer:'',
    cookie_user: ''
  },
  mutations: {
    increment(state) {
      // 变更状态
      // window.localStorage.setItem('token', '');
      state.user = '',
      state.cookie_user = ''
    },
    // async updateInfo(state,data){
    //   await setLocalStorage(data.key,data.value)
    // }
  },
  actions: {
    LogOut(context) {
      context.commit('increment')
    },
    // updateInfo(context,data) {
    //   context.commit('updateInfo',data)
    // },
  },
  modules: {

  }
})
